import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { promptTypeOptionActions } from 'src/app/common-components/entity-select/prompt-type/state/prompt-type-option.actions';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { getPromptPrivileges } from 'src/app/privileges/privileges.selector';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { PromptPrivileges } from '../models/prompt-privileges';
import { PromptRegisterOptions } from '../models/prompt-register-options';
import { PromptRegisterListItem } from '../models/prompt-register-results.model';
import { PromptsFilterOption } from '../models/prompts-filter-option';
import {
   createPrompt,
   promptRegisterAdapterActions,
   promptRegisterInitialFilter,
} from '../state/prompt-register.actions';
import * as promptRegisterReducer from '../state/prompt-register.reducer';
import { getShowExtensionRegisterPopupUserPreference } from 'src/app/store/user-preferences/user-preferences.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-prompt-register',
    styleUrls: ['./prompt-register.component.scss'],
    templateUrl: './prompt-register.component.html',
    standalone: false
})
export class PromptRegisterComponent
   extends Register<PromptRegisterListItem, PromptRegisterOptions, OrderingOption>
   implements OnInit
{
   entityName = 'Prompt';

   columns: string[] = ['name', 'type', 'active', 'inUse', 'promptActionsMenu'];

   includeInactive$: Observable<boolean>;

   promptPrivileges$: Observable<PromptPrivileges>;

   showExtensionRegisterPopup$: Observable<boolean>;

   filters: PromptsFilterOption[];

   constructor(public store: Store) {
      super(store, promptRegisterReducer.selectors, promptRegisterAdapterActions);
      this.store.dispatch(promptTypeOptionActions.load({}));
      this.promptPrivileges$ = store.pipe(select(getPromptPrivileges));
      this.showExtensionRegisterPopup$ = this.store.pipe(
                     select(getShowExtensionRegisterPopupUserPreference),
                     map((isTooltipsShown) => isTooltipsShown ?? true)
                  );

      store
         .select(getSelectedAccountId)
         .pipe(
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            }),
            map((accountId: number) => {
               const filters: PromptsFilterOption[] = [
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: accountId,
                  },
                  {
                     field: 'IsReusable',
                     operation: FilterOperations.EqualTo,
                     type: 'boolean',
                     value: true,
                  },
                  {
                     field: 'TypeId',
                     operation: FilterOperations.NotEqualTo,
                     type: 'numeric',
                     value: 7,
                  },
                  {
                     field: 'IsActive',
                     operation: FilterOperations.EqualTo,
                     type: 'boolean',
                     value: true,
                  },
               ];
               return filters;
            })
         )
         .subscribe((filters) => {
            this.filters = filters;
         });
   }

   ngOnInit() {
      this.store.dispatch(promptRegisterInitialFilter({ filters: this.filters }));
      this.store.dispatch(this.actions.pageEnter());
   }

   onCreate(): void {
      this.store.dispatch(createPrompt());
   }
}
